import * as fflate from "fflate";
import { ILazyAttachment } from "../models/zip_content.ts";

export const extractZipContents = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  const zipData = new Uint8Array(arrayBuffer);

  // まずファイル名一覧だけ収集（バイナリは展開しない）
  const fileNames: string[] = [];
  fflate.unzipSync(zipData, {
    filter: (fileInfo) => {
      fileNames.push(fileInfo.name);
      return false; // 全ファイルの展開をスキップ
    },
  });

  // import.csvがルート直下にあるかチェックし、親ディレクトリの有無を判定
  const hasParentDir = !fileNames.some((p) => p === "import.csv");

  // CSVファイルのみ展開
  const csvPath = hasParentDir
    ? fileNames.find((p) => removeFirstSegment(p) === "import.csv")
    : "import.csv";

  if (!csvPath) {
    throw new Error("import.csvがZipファイル内にありません。");
  }

  const csvEntries = fflate.unzipSync(zipData, {
    filter: (fileInfo) => fileInfo.name === csvPath,
  });
  const csvContent = csvEntries[csvPath];
  if (!csvContent) {
    throw new Error("import.csvがZipファイル内にありません。");
  }
  const csvFile = new File([csvContent.buffer as ArrayBuffer], "import.csv", {
    type: "text/csv",
  });

  // 添付ファイル・インライン画像は名前だけ記録し、content は遅延取得
  const attachments: ILazyAttachment[] = [];
  const inlineImages: ILazyAttachment[] = [];

  for (const rawPath of fileNames) {
    const path = hasParentDir ? removeFirstSegment(rawPath) : rawPath;

    if (path.startsWith("attachments/") && path !== "attachments/") {
      attachments.push({
        name: path.replace("attachments/", ""),
        getContent: () => extractSingleFile(zipData, rawPath),
      });
    } else if (path.startsWith("inline_images/") && path !== "inline_images/") {
      inlineImages.push({
        name: path.replace("inline_images/", ""),
        getContent: () => extractSingleFile(zipData, rawPath),
      });
    }
  }

  return { csvFile, attachments, inlineImages };
};

/** ZIPから指定パスのファイルだけを展開する */
const extractSingleFile = (
  zipData: Uint8Array,
  targetPath: string,
): Uint8Array => {
  const entries = fflate.unzipSync(zipData, {
    filter: (fileInfo) => fileInfo.name === targetPath,
  });
  const content = entries[targetPath];
  if (!content) {
    throw new Error(`ZIPファイル内に "${targetPath}" が見つかりません。`);
  }
  return content;
};

const removeFirstSegment = (path: string) => {
  const index = path.indexOf("/");
  if (index !== -1) {
    return path.slice(index + 1);
  }
  return path;
};
